'use strict';
var utils = require('pagedesigner/util/utils');

var synchTileElements = function () {
    let $tiles = $('.product-jump-tile, .einstein .product-tile');
    utils.syncHeights($tiles.find('.tile-heading > div'));
    utils.syncHeights($tiles.find('.pdp-link'));
    utils.syncHeights($tiles.find('.price-container')); // for OOS prods
    utils.syncHeights($tiles.find('.tile-desc'));
    utils.syncHeights($tiles.find('.promo-callout-container')); // for OOS prods
    utils.syncHeights($tiles.find('.tile-add-to-cart')); // for OOS prods

    // If tile Affirm has loaded, sync tile heights
    if ($tiles.find('.affirm-modal-trigger').length > 0) {
        utils.syncHeights($tiles.find('.tile-affirm')); // for OOS prods
    } else {
        // If tile Affirm has not loaded, use the inline height attribute until mutation is observed and a new height is set
        let affirmH = $tiles.find('.affirm-as-low-as').attr('height');
        let $affirmWrapper = $tiles.find('.tile-affirm');
        $affirmWrapper.each(function () {
            $(this).css('height', affirmH);
        });
    }
    // synch individual features
    for (var i = 1; i < 11; i++) {
        let $feature = $('.feature' + i.toString());
        if ($feature.length > 0) {
            utils.syncHeights($feature);
        }
    }
    // sync Product Family Chart Features
    let $chartTh = $('.chart-product-th');
    if ($chartTh.length > 0) utils.syncHeights($chartTh);
    let $chartImgContainer = $('.chart-product-th .image-container');
    if ($chartImgContainer.length > 0) utils.syncHeights($chartImgContainer);
    $('.family-chart-body').slick({
        mobileFirst: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        appendDots: $('.family-chart-dots'),
        accessibility: false,
        dots: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    variableWidth: true
                }
            },
            {
                breakpoint: 921,
                settings: {
                    slidesToShow: 3,
                    centerMode: false,
                    variableWidth: true
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 4,
                    centerMode: false,
                    variableWidth: true
                }
            },
            {
                breakpoint: 1026,
                settings: {
                    slidesToShow: 5,
                    centerMode: false,
                    variableWidth: true
                }
            }
        ]
    });
};

var pdProductTiles = {
    initJumpTiles: function () {
        if ($('.product-jump-tile').length > 0) {
            // preemptive synching
            pdProductTiles.synchTileElements();
            $(window).on('resize', function () {
                pdProductTiles.synchTileElements();
            });

            // Sync heights of tile Power Reviews and Affirm element; the 3rd party scripts that inject these elements are deferred to improve performance
            let $powerreivewsEl = $('.product-jump-tile .p-w-r');
            utils.mutationObserver($powerreivewsEl, function () {
                pdProductTiles.synchTileElements();
            });
            let $affirmEl = $('.product-jump-tile .tile-affirm');
            utils.affirmObserver($affirmEl, function () {
                pdProductTiles.synchTileElements();
            });
        }
    },
    synchTileElements: synchTileElements,
    /**
     * @function
     * @desc Inits the Product Detail Tile Use it With replenishment products drawer handling
     */
    initDetailTiles: function () {
        var base = require('org/product/base');
        var carouselInit = require('pagedesigner/experience/carousels');
        base.carouselInit();
        carouselInit.pdReplenishmentCaro();
        // handle slider inside drawer
        let $drawerParent = $('.replenishment-products-slider');
        let $drawerContent = $drawerParent.find('.collapse');
        $drawerContent.each(function () {
            $(this).on('show.bs.collapse', function () {
                // hidden carousels
                var $slider = $(this).find('.slick-initialized');
                if ($slider.length > 0) {
                    // hide the slider until it is init'd properly
                    $slider.css('opacity', 0);
                    // destroy and reinit slider
                    $slider.slick('unslick');
                    carouselInit.pdReplenishmentCaro();
                    // show the slider
                    $slider.css('opacity', 1);
                }
            });
        });
    }

};

module.exports = pdProductTiles;
